/**
 * Config-driven branding for TraceOS landing pages
 */

import type { TraceKitConfig } from '../../types/config';

export interface LandingBranding {
  appName: string;
  companyName: string;
  primaryColor: string;
  secondaryColor: string;
  subtitle: string;
  logo?: string;
  logoUrl?: string;
  logoAlt?: string;
}

const DEFAULT_PRIMARY = '#3b82f6';
const DEFAULT_SECONDARY = '#2563eb';

export function getLandingBranding(config: TraceKitConfig | null | undefined): LandingBranding {
  if (!config?.branding) {
    return {
      appName: 'TraceKit',
      companyName: '',
      primaryColor: DEFAULT_PRIMARY,
      secondaryColor: DEFAULT_SECONDARY,
      subtitle: 'Evidence-driven platform',
    };
  }
  const b = config.branding;
  const showLandingSubtitle = b.showLandingNavbarSubtitle !== false;
  return {
    appName: b.appName ?? 'TraceKit',
    companyName: b.companyName ?? '',
    primaryColor: b.primaryColor ?? DEFAULT_PRIMARY,
    secondaryColor: b.secondaryColor ?? DEFAULT_SECONDARY,
    subtitle: showLandingSubtitle ? (b.platformSubtitle ?? 'Evidence-driven platform') : '',
    logo: b.logo,
    logoUrl: (b as any).landingLogoUrl ?? b.logoUrl,
    logoAlt: (b as any).landingLogoAlt ?? b.logoAlt,
  };
}
